<template>
  <div class="right-chart-2" id="right-chart-2"></div>
</template>

<script>
import { selectInspectSelectBrand } from '@/api/modules/dataView.js'
export default {
  name: 'RightChart2',
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
          hxcs_position: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const echartsDom = document.getElementById('right-chart-2')
      this.chart = this.$echarts.init(echartsDom)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const apiData = await selectInspectSelectBrand(this.params)
      const echartsData = []
      const xData = []
      if (apiData) {
        apiData.forEach(item => {
          xData.push(item.hxcs_position)
          echartsData.push(item.yxsysc_bwjccs)
        })
      }
      const options = {
        title: {
          text: `${this.params.hxcs_position}部位检查品牌情况`,
          top: '20px',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        grid: {
          top: 80,
          bottom: 40,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          data: xData,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
        },
        series: [
          {
            data: echartsData,
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
            },
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss" scoped>
.right-chart-2 {
  width: 100%;
  height: 43%;
  display: flex;
  flex-direction: column;
}
</style>
